<template>
  <b-modal
    id="addBankModal"
    :headerClass="`add-vello-icon`"
    centered
    hide-footer
  >
    <p class="text-justify mt-n3 mb-4">
      Please submit your bank details so we can send your monthly earnings
    </p>

    <b-form @submit.prevent="onSubmit">
      <b-row no-gutters>
        <b-col cols="12" class="mb-0">
          <b-form-group class="col-12 mb-3">
            <h6>Name</h6>
            <b-form-input
              ref="nameField"
              v-model="form.full_name"
              class="form-control effect-26"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 mb-3">
            <h6>Bank Name</h6>
            <b-form-input
              ref="bankField"
              v-model="form.bank_name"
              class="form-control effect-26"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 mb-3">
            <h6>Bank Address</h6>
            <b-form-input
              ref="bankAddrField"
              v-model="form.bank_address"
              class="form-control effect-26"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 mb-3">
            <h6>Residential Address</h6>
            <b-form-input
              v-model="form.residential_address"
              class="form-control effect-26"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 mb-3">
            <h6>Routing Number</h6>
            <b-form-input
              ref="routingField"
              v-model="form.routing_number"
              class="form-control effect-26"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 mb-3">
            <h6>Account Number</h6>
            <b-form-input
              ref="accNumField"
              v-model="form.account_number"
              class="form-control effect-"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-row>
            <b-col cols="12" class="m-auto px-3">
              <b-button
                class="rounded-pill"
                type="submit"
                variant="primary"
                block
              >
                <b-spinner small v-if="form.$busy" /> Submit
              </b-button>

              <!-- API Error Message -->
              <div
                class="mt-4 text-warning"
                v-if="form.$errorMessage"
                v-text="'Uh oh, ' + form.$errorMessage.toLowerCase() + ' 😢'"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import Form from '@/utils/form'

export default {
  name: 'addBankModal',
  props: ['bank'],

  data() {
    return {
      form: new Form({
        full_name: '',
        bank_name: '',
        bank_address: '',
        residential_address: '',
        routing_number: '',
        account_number: '',
      }),
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  methods: {
    async onSubmit(evt) {
      this.form.$busy = true

      await this.$api
        .post('payout/manual/bank', this.form.$data())
        .then(({ data }) => {
          this.form.$busy = false
          this.$bvModal.hide('addBankModal')
          this.successToast('Successfully saved!')
          this.$emit('reload')
        })
        .catch((error) => {
          this.form.$handleError(error)
        })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        noCloseButton: true,
        variant: 'success',
        toaster: 'b-toaster-bottom-right',
      })
    },
  },

  created() {
    let vm = this

    if (vm.user) {
      vm.form.full_name = vm.user.full_name
    }

    if (vm.bank) {
      vm.form.full_name = vm.bank.full_name
      vm.form.bank_name = vm.bank.bank_name
      vm.form.bank_address = vm.bank.bank_address
      vm.form.residential_address = vm.bank.residential_address
      vm.form.routing_number = vm.bank.routing_number
      vm.form.account_number = vm.bank.account_number
    }
  },

  watch: {
    form() {
      this.form.$clearErrorMessage()
    },
  },
}
</script>

<style scoped></style>
